var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingIco1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.449,
    height: 62.449,
    viewBox: "0 0 62.449 62.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.291,
    x2: 0.5,
    y2: 1.866,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2979ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fcbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -1.091,
    x2: 0.5,
    y2: 10.904,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M2230.955,2538.658l1.061,10.291,4.081-.421a27.123,27.123,0,0,0,5.184,9.614l-2.581,3.176,8.026,6.526,2.582-3.176a27.109,27.109,0,0,0,10.469,3.114l.421,4.083,10.29-1.061-.42-4.082a27.109,27.109,0,0,0,9.614-5.184l3.176,2.583,6.526-8.026-3.175-2.583a27.084,27.084,0,0,0,3.114-10.469l4.082-.42-1.061-10.291-4.082.42a27.093,27.093,0,0,0-5.184-9.615l2.582-3.176-8.026-6.527-2.582,3.176a27.125,27.125,0,0,0-10.469-3.114l-.42-4.082-10.292,1.061.422,4.082a27.094,27.094,0,0,0-9.614,5.185l-3.176-2.583-6.527,8.026,3.176,2.581a27.108,27.108,0,0,0-3.113,10.47Zm29.428-15.445a17.519,17.519,0,1,1-15.63,19.222A17.519,17.519,0,0,1,2260.383,2523.213Z",
    transform: "translate(-2230.955 -2509.415)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M2312.427,2594.544a4.1,4.1,0,1,0-4.5-3.657A4.1,4.1,0,0,0,2312.427,2594.544Z",
    transform: "translate(-2280.781 -2559.242)",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIco1);
export default __webpack_public_path__ + "static/media/settingIco1.14366e6f10ac3433323dbe2bf0db0543.svg";
export { ForwardRef as ReactComponent };